import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "@/lib/api";

export default function NotificationBell() {
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = async () => {
    try {
      const res = await api.get("/notifications");
      setData(res.data);
    } catch {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="notification-bell"
        onClick={() => setOpen((o) => !o)}
        className="relative w-10 h-10 rounded-full hover:bg-slate-100 flex items-center justify-center transition-colors"
      >
        <Bell size={20} className="text-[#1f222d]" />
        {data.unread > 0 && (
          <span data-testid="notification-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-blue-600 text-white text-[10px] font-bold flex items-center justify-center">
            {data.unread}
          </span>
        )}
      </button>

      {open && (
        <div data-testid="notification-dropdown" className="absolute right-0 mt-2 w-80 bg-white rounded-2xl shadow-xl border border-slate-200 z-50 overflow-hidden">
          <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
            <span className="font-semibold text-[#1f222d]">Bildirimler</span>
            {data.unread > 0 && (
              <button data-testid="mark-all-read" onClick={markAll} className="text-xs text-blue-600 font-medium hover:underline">
                Tümünü okundu yap
              </button>
            )}
          </div>
          <div className="max-h-96 overflow-y-auto">
            {data.notifications.length === 0 ? (
              <p className="text-sm text-slate-400 text-center py-8 px-4">Henüz bildiriminiz yok. Profilinizi doldurup AI eşleştirmeyi deneyin!</p>
            ) : (
              data.notifications.map((n) => (
                <Link
                  key={n.id}
                  to={n.job_slug ? `/ilan/${n.job_slug}` : "#"}
                  onClick={() => setOpen(false)}
                  className={`block px-4 py-3 border-b border-slate-50 hover:bg-slate-50 transition-colors ${!n.read ? "bg-blue-50/40" : ""}`}
                >
                  <div className="flex items-start gap-2">
                    {!n.read && <span className="w-2 h-2 rounded-full bg-blue-600 mt-1.5 shrink-0" />}
                    <div>
                      <p className="text-sm font-semibold text-[#1f222d]">{n.title}</p>
                      <p className="text-xs text-slate-500 mt-0.5 line-clamp-2">{n.message}</p>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
